// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import Gallery from "./Gallery";
import MobileGallery from "./MobileGallery";
import { withListingContext } from "./ListingContext";
import type { CompliantListingType, $OpenHouses } from "flow/types";

type $Props = {
  classes: Object,
  className: string,
  listing: CompliantListingType,
  openHouses: $OpenHouses,
  isV1: boolean,
};

const Hero = ({ classes, className, listing, openHouses, isV1 }: $Props) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div id="ref__imageCount" className="hidden">
        {listing.photoCount}
      </div>
      <div
        className={classes.background}
        style={{
          backgroundImage: `url('${listing.firstPhoto}&fit=crop&w=1280&or=0')`,
        }}
      />

      <Gallery
        openHouses={openHouses}
        className={classes.gallery}
        isV1={isV1}
      />
      <MobileGallery
        openHouses={openHouses}
        className={classes.mobileGallery}
        isV1={isV1}
      />
    </div>
  );
};

export default withStyles((theme) => ({
  background: {
    display: "none",
  },
  gallery: {
    display: "none",
  },
  mobileGallery: {
    display: "flex",
  },
  [theme.breakpoints(900)]: {
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      width: `100%`,
      height: `560px`,
      overflow: "hidden",
      ...theme.globalPadding,
      ".ie-11 &": {
        alignItems: "flex-start",
      },
    },
    gallery: {
      display: "grid",
    },
    mobileGallery: {
      display: "none",
    },
    background: {
      display: "flex",
      position: "absolute",
      width: "calc(100% + 16px)", // extra because of the blur filter
      height: "calc(100% + 16px)", // extra because of the blur filter
      backgroundColor: theme.colors.gray["800"],
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      filter: "blur(4px) brightness(50%)",
      ".ie-11 &": {
        "&:after": {
          display: "block",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          content: "''",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      },
    },
  },
}))(withListingContext(Hero));
